import { getDoneTotalMandatoryItems, getDoneTotalOptionalItems } from "./misc";

export const rmBgItemsAsArray = ({ bg = {} } = {}) => ({
    qualifications: Object.values(bg?.qualifications || {}),
    jobs: Object.values(bg?.jobs || {}),
    languages: Object.values(bg?.languages || {}),
    competences: Object.values(bg?.competences || {}),
    materials: Object.values(bg?.materials || {})
});

export const completionPercentage = (rm, cv, user, games) => {
    if (!rm || !cv)
        return {
            mandatory: 0,
            optional: 0
        };

    const counter = {
        mandatory: getDoneTotalMandatoryItems(rm, cv, user, games),
        optional: getDoneTotalOptionalItems(rm, cv)
    };

    return {
        mandatory: counter.mandatory.total === 0 ?
            (counter.mandatory.done === 0 ? 100 : 0) : Math.round(counter.mandatory.done / counter.mandatory.total * 100),

        optional: counter.optional.total === 0 ? (
            counter.optional.done === 0 ? 100 : 0) : Math.round(counter.optional.done / counter.optional.total * 100)
    };
};

export const completionWeightedPercentage = (rm, cv, user, games) => {
    let counter = {
        mandatory: 0,
        optional: 0
    };

    if (!rm)
        return counter;

    counter = {
        mandatory: getDoneTotalMandatoryItems(rm, cv, user, games),
        optional: getDoneTotalOptionalItems(rm, cv)
    };

    const weight = {
        mandatory: 0.8,
        optional: 0.2
    };

    let mandatory;
    if (counter.mandatory.total === 0) {

        if (counter.mandatory.done === 0)
            mandatory = 100 * weight.mandatory
        else
            mandatory = 0;

    } else {
        mandatory = counter.mandatory.done / counter.mandatory.total * weight.mandatory * 100;
    }

    let optional;
    if (counter.optional.total === 0) {
        if (counter.optional.done === 0)
            optional = 100 * weight.optional
        else
            optional = 0;
    } else {
        optional = counter.optional.done / counter.optional.total * weight.optional * 100;
    }

    return {
        mandatory,
        optional
    };
};